import {ButtonPriority} from '@wix/wix-ui-tpa';
import {Button} from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import classNames from 'clsx';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {SPECS} from '../../../domain/specs';
import {classes} from './CartButton.st.css';

export enum CartButtonDataHooks {
  root = 'CartButtonDataHooks.root',
}

export interface CartButtonProps {
  className?: string;
  text: string;
}

export const CartButton = ({className, text}: CartButtonProps) => {
  const {navigateToCart} = useControllerProps().navigationStore;
  const {experiments} = useExperiments();
  const shouldIgnoreTextOpacity = experiments.enabled(SPECS.ecomIgnoreCartButtonsTextOpacity);

  return (
    <Button
      className={classNames(
        /* istanbul ignore next */ shouldIgnoreTextOpacity ? classes.button : classes.buttonOld,
        className
      )}
      data-hook={CartButtonDataHooks.root}
      priority={ButtonPriority.basicSecondary}
      onClick={() => navigateToCart()}
      upgrade
      fullWidth>
      {text}
    </Button>
  );
};
